module.exports = __webpack_public_path__ + "assets/img/block-left-hover-54ec0b1f.png";